import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { onIdTokenChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { captureReferral, getReferralVia, referralFromSearch, referralRequest } from '../utils/referrals';
import { trackReferralClaimResult, trackReferralLanding } from '../utils/referralTracking';

export default function ReferralCapture() {
  const { search } = useLocation();
  useEffect(() => {
    const code = captureReferral();
    trackReferralLanding({ hasCode: Boolean(code) });
    if (!code) return undefined;
    const via = getReferralVia();
    try {
      let visitor = window.localStorage.getItem('cfa_referral_visitor');
      if (!visitor) {
        visitor = window.crypto.randomUUID();
        window.localStorage.setItem('cfa_referral_visitor', visitor);
      }
      referralRequest('visit', { code, visitor, via }).catch(() => {});
    } catch { /* referral savings do not depend on analytics storage */ }
    return onIdTokenChanged(auth, user => {
      if (user?.emailVerified) referralRequest('claim', { code, via }).then(r => trackReferralClaimResult({ attributed: r?.attributed === true }), () => trackReferralClaimResult({ reason: 'error' }));
    });
  }, []);
  return referralFromSearch(search) ? <div className="page-shell">
    <p style={{ fontSize: 13, margin: '8px 0' }}>Referred by a friend? <a href="/referral-terms/">Referral terms</a></p>
  </div> : null;
}
